<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Generuj etykietę
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-file-input
                            v-model="currentFile"
                            label="Plik excel"
                            accept=".xls, .xlsx"
                            counter
                            placeholder="Wybierz plik"
                            prepend-icon="mdi-paperclip"
                            outlined
                            dense
                            :rules="[fileError]"
                            :show-size="1000"
                        />
                    </v-col>
                </v-row>

                <v-divider />
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        @click="onClose()"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        text
                        data-sentry-label="Wyślij plik"
                        :disabled="!canUpload"
                        @click="onLoaded"
                    >
                        <v-icon left>
                            mdi-file-upload
                        </v-icon>
                        Wyślij
                    </v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import * as XLSX from 'xlsx'

export default {
    name: 'GenerateBillboardLabelsDialog',
    props: {
        isOpen: {
            type: Boolean
        }
    },
    data() {
        return {
            reader: null,
            currentFile: null,
            xlsData: null,
            isValidFileTriger: true,
        }
    },
    computed: {
        canUpload() {
            return this.currentFile && this.isValidFileTriger
        },
        fileError() {
            return this.isValidFileTriger || 'Niepoprawny format danych w pliku.'
        }
    },
    watch: {
        currentFile(value) {
            if (value !== null && value !== undefined) {
                this.reader.readAsBinaryString(value)
            } else {
                this.currentFile = null
                this.xlsData = null
                this.isValidFileTriger = true
            }
        },
        xlsData(data) {
            if (this.currentFile !== null) {
                this.isFileValid(data)
            }
        }
    },
    mounted() { 
        this.reader = new FileReader()
            
        this.reader.onload = (e) => {
            const bstr = e.target.result
            const wb = XLSX.read(bstr, { type: 'binary' })
            /* Get first worksheet */
            const wsname = wb.SheetNames[0]
            const ws = wb.Sheets[wsname]

            this.xlsData = XLSX.utils.sheet_to_json(ws, { header: 1, defval: null })

            const firstNullIndex = this.xlsData[0].findIndex(value => value === null)
            const columnRangeIndex = firstNullIndex === -1 ? this.xlsData[0].length : firstNullIndex
            let rowRangeIndex = this.xlsData.length

            this.xlsData.some((row, index) => {
                if (row[0] === null) {
                    rowRangeIndex = index
                    
                    return true
                }
            })

            // Trim rows 
            this.xlsData = this.xlsData.slice(0, rowRangeIndex)

            // Trim columns
            this.xlsData.forEach(row => {
                row.splice(columnRangeIndex)
            })
        }
    },
    methods: {
        isFileValid(data) {
            if (data === null) {
                return (this.isValidFileTriger = false)
            } else if (!data[0].length) {
                return (this.isValidFileTriger = false)
            }
            
            if (!data[0].slice(0, 2).every(
                item => {
                    let formattedItem = typeof item == 'string' ? item.trim() : item

                    return ['Trasa', 'Nazwa ekipy'].includes(formattedItem)
                }
            )) {
                return (this.isValidFileTriger = false)
            }

            return (this.isValidFileTriger = true)
        },
        onClose() {
            this.$emit('on-close')

            setTimeout(() => {
                this.xlsData = null
                this.currentFile = null
            }, 500)
        },
        onLoaded() {
            this.$emit('on-loaded', {data: this.xlsData, fileName: this.currentFile.name})
            this.onClose()
        },
    }
} 
</script>